import { useApplicationStore } from '@data';
import { Paragraph } from '@quickmd-llc/design-system';
import { PatientProfile } from '@qmd-types/patient';

type Props = { hideSubtext?: boolean };

export function RefillDeliveryAddress({ hideSubtext = false }: Props) {
  const patientProfile = useApplicationStore(
    ({ patient }) => patient.patientProfile,
  );

  if (!patientProfile) {
    return null;
  }

  const deliveryAddress = formatDeliveryAddress(patientProfile);

  return (
    <>
      <Paragraph className="mb-2 font-semibold text-shade-95">
        Delivery Address
      </Paragraph>

      <Paragraph className="text-shade-95">{deliveryAddress}</Paragraph>

      {!hideSubtext && (
        <Paragraph className="mt-2 text-shade-80" size="sm">
          If you need this medication shipped to another address, please book a
          new visit with your doctor.
        </Paragraph>
      )}
    </>
  );
}

function formatDeliveryAddress(patientProfile?: PatientProfile) {
  const address = patientProfile?.address;

  if (!address) {
    return '';
  }

  const { streetAddress1, streetAddress2, city, stateCode, zip } = address;

  return `${streetAddress1}${streetAddress2 ? ` ${streetAddress2}` : ''}, ${city}, ${stateCode} ${zip}`;
}
